<template>
    <el-form :model="signInForm" label-width="120px">
        <el-row :gutter="24">
            <el-col :span="6">
                <el-form-item label="运单号：">
                    <div class="inputValue">
                        {{ signInForm.waybillNo }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="6">
                <el-form-item label="客户订单号：">
                    <div class="inputValue">
                        {{ signInForm.customerOrderNo }}
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>
<script>
export default {
    name: 'signInForm',
    data () {
        return {
            signInForm: {
                waybillNo: '',
                customerOrderNo: ''
            }
        };
    },
    methods: {
        /**
         * @description 初始化用户签收详情表单字段值
         * @param {Object} data 接口返回的回单数据
         */
        initFormData (data) {
            this.signInForm.waybillNo = data.waybillNo;
            this.signInForm.customerOrderNo = data.customerOrderNo;
        }
    }
};
</script>
